export const formStructure = [
  [
    {
      name: 'frota',
      label: 'Frota',
      placeholder: 'Número da frota',
      component: 'FormField',
      type: 'text',
      colProps: { md: 12 },
    },
  ],
  [
    {
      name: 'vazioem',
      label: 'Vazio em',
      placeholder: 'Digite aonde está vazio',
      component: 'FormField',
      type: 'text',
      colProps: { md: 4 },
    },
    {
      name: 'diasParados',
      label: 'Dias parados',
      placeholder: 'Dias parados',
      component: 'FormField',
      type: 'number',
      colProps: { md: 4 },
      disabled: true
    },
    {
      name: 'DataDisponibilidade',
      label: 'Data de disponibilidade',
      placeholder: '',
      component: 'DatePickers',
      type: 'date',
      colProps: { md: 4 },
    },
  ],
  [
    {
      name: 'destino',
      label: 'Destino',
      placeholder: 'Destino',
      component: 'FormField',
      type: 'text',
      colProps: { md: 8 },
    },
    {
      name: 'uf',
      label: 'UF',
      placeholder: 'Digite a UF',
      component: 'FormField',
      type: 'text',
      colProps: { md: 4 },
    },
  ],
  [
    {
      name: 'responsavelComercial',
      label: 'Comercial',
      placeholder: 'Digite o comercial responsável',
      component: 'FormField',
      type: 'text',
      colProps: { md: 6 },
    },
    {
      name: 'gestor',
      label: 'Gestor',
      placeholder: 'Digite o gestor responsável',
      component: 'FormField',
      type: 'text',
      colProps: { md: 6 },
    },
  ],
  [
    { name: 'vazio', label: 'Vazio', component: 'CheckBox', type: 'checkbox', colProps: { md: 'auto' } },
    { name: 'coleta', label: 'Coleta', component: 'CheckBox', type: 'checkbox', colProps: { md: 'auto' } },
    { name: 'negociacao', label: 'Negociação', component: 'CheckBox', type: 'checkbox', colProps: { md: 'auto' } },
  ],
];

export const formSections = (initialValues) => [
  {
    title: `Detalhes da frota ${initialValues.frota || ''}`,
    rows: [0, 1, 2] // Renderiza as linhas 0, 1 e 2 da formStructure
  },
  {
    title: 'RESPONSÁVEIS',
    rows: [3] // Renderiza a linha 3
  },
  {
    title: 'Informações Gerais',
    rows: [4] // Renderiza a linha 4
  }
];